import { ref } from 'vue'

const DEV_TOOLS_STORAGE_KEY = 'cady:devToolsUnlocked'

const isAutoUnlocked = import.meta.env.DEV || import.meta.env.DEMO

/** Reactive flag — true when DevDrawer should be visible. */
export const isDevToolsUnlocked = ref(
  isAutoUnlocked || sessionStorage.getItem(DEV_TOOLS_STORAGE_KEY) === 'true'
)

/**
 * Unlock dev tools for this browser session.
 * Called from the browser console: `enableDevTools('password')`
 */
function enableDevTools(password: string): string {
  const expected = import.meta.env.VITE_DEV_TOOLS_PASSWORD
  if (!expected) return 'Dev tools password not configured.'
  if (password !== expected) return 'Incorrect password.'

  sessionStorage.setItem(DEV_TOOLS_STORAGE_KEY, 'true')
  isDevToolsUnlocked.value = true
  return 'Dev tools enabled for this session.'
}

/**
 * Lock dev tools again for this browser session.
 * Called from the browser console: `disableDevTools()`
 */
function disableDevTools(): string {
  sessionStorage.removeItem(DEV_TOOLS_STORAGE_KEY)
  isDevToolsUnlocked.value = false
  return 'Dev tools disabled.'
}

// Attach to window so they're callable from the browser console.
// NOTE: The VITE_DEV_TOOLS_PASSWORD value is baked into the client bundle
// at build time. This password is a speed-bump to prevent accidental use,
// not a security boundary.
;(window as any).enableDevTools = enableDevTools
;(window as any).disableDevTools = disableDevTools
